import {
  extend,
  params,
  arrayOf as arrayOfType,
  string as stringType,
  shape as shapeType,
} from '@thd-nucleus/data-sources';
import { RequestAQuoteCta, ScheduleAConsultationCta } from '@thd-olt-component-react/home-services-cta-buttons';

export const dataModel = extend({
  product: params({ itemId: stringType().isRequired(), dataSource: stringType() }).shape({
    itemId: stringType(),
    dataSources: stringType(),
    details: shapeType({
      installation: shapeType({
        programCategory: stringType(),
        salientPoints: arrayOfType(stringType()),
        leadGenUrl: stringType(),
      }),
    })
  }),
}, RequestAQuoteCta, ScheduleAConsultationCta);
